const React = require('react');
const PropTypes = require('prop-types');

require('./ColorSwatch.scss');


const ColorSwatch = ({ color }) => (
    <div className="color-swatch" style={{ backgroundColor: color }} />
);


ColorSwatch.propTypes = {
    color: PropTypes.string.isRequired,
};


module.exports = ColorSwatch;
